import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Logo from "@components/Logo/logo";

import { Link, useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import { motion } from "framer-motion";

function HomeCreateAccount() {
  const navigate = useNavigate();
  const welcomeText = "Bem-vindo ao portal do cliente!";

  // handle initial route
  const handleNewAccess = e => {
    e.preventDefault();
    navigate("/Cadastro");
  };

  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.2 } }}
      exit={{ opacity: 0 }}
    >
      <Row className="home-create-access">
        <Logo welcomeText={welcomeText} />
        <Col
          xs="12"
          className="d-flex align-items-center flex-wrap flex-column"
        >
          <span className="access__container">
            <Button
              sx={{ borderRadius: 28 }}
              variant="contained"
              color="primary"
              className="btn-create-access"
              onClick={handleNewAccess}
            >
              <AddIcon />
              <span>Criar Acesso</span>
            </Button>
        
            <Link to="/Entrar" className="btn-login-access">
              Já possuo uma conta
            </Link>
          </span>
        </Col>
      </Row>
    </motion.span>
  );
}

export default HomeCreateAccount;
